import React, { useEffect, useId } from "react";
import "./reels.css";

/**
 * Explicit confirmation for destructive reel actions. window.confirm is the
 * house style elsewhere in the console, but deleting a reel permanently
 * destroys an uploaded video, its comments and its stats; that warrants
 * spelling out what is about to go, not a one-line browser prompt.
 */
export default function ReelConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Delete",
  destructive = true,
  busy = false,
  onConfirm,
  onCancel,
}) {
  const titleId = useId();
  const messageId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape" && !busy) onCancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, busy, onCancel]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={() => !busy && onCancel()}>
      <div
        className="modal reel-confirm-modal"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
      >
        <div className="modal-body">
          <h2 id={titleId} className="reel-confirm-title">{title}</h2>
          <p id={messageId} className="reel-confirm-text">{message}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn-secondary" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className={destructive ? "btn-danger" : "btn-primary"}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy && <span className="btn-spinner" aria-hidden="true" />}
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
